import { IMAGE_PREFIX_ID } from '@frontend/constants/templates-field-prefixes';
import API_MEDIA from '../../frontend/services/api/media';
import {
  calculateDataForAllProductImages, getLockValue, getShadowFabricInstance,
  isInGroup,
  removeObjectFromCanvas,
  updateBoundingBoxInfo
} from '@frontend/utils';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { FIELD_TYPE_PRODUCT_IMAGE } from '@frontend/constants/type-fields-of-template';
import { formDataToObject } from '@frontend/lib/utils/form-data-to-object';
import { scaleControlsCornerSize } from '@frontend/constants/fabric-constants';
import {getGroupNameByAddFieldId} from "@/common/preview/draw-smart-object";

const getScopePage = () => ShowPageScopeCollector.get([
  'canvas_data',
  'updateLayoutChanges',
  'selectedObjects',
  'reorderObjectCanvas',
]);
const countrySelect = $('select[name="country_id"]');
const languageSelect = $('select[name="language_id"]');

export async function drawProductImage({
  data,
  canvas,
  id,
  shadows,
  group_fields,
  dimension,
  previewBoundingBoxData
}) {
  const prevObjWithDataForRestoreOriginalPaths = canvas.getObjects().find(obj => obj.id.startsWith(IMAGE_PREFIX_ID)
    && Object.hasOwn(obj, 'originalPathForRestoreAfterCrop')
    && obj.originalPathForRestoreAfterCrop);
  const originalPathForRestoreAfterCrop = 
    prevObjWithDataForRestoreOriginalPaths ? prevObjWithDataForRestoreOriginalPaths.originalPathForRestoreAfterCrop : '';
  removeObjectFromCanvas(canvas, IMAGE_PREFIX_ID);
  const { canvas_data, updateLayoutChanges, reorderObjectCanvas } = getScopePage();
  canvas_data[id].originCoords = [];
  
  let file_ids = (data['file_ids'] || '').split(/[, ]+/);
  if (data.product_texts) {
    const country = countrySelect.val();
    const language = languageSelect.val();
    const product_texts = JSON.parse(data.product_texts);
    const text_data = product_texts[country + '_' + language];
    
    if (text_data && text_data.productIDs) {
      file_ids = text_data.productIDs.split(/[, ]+/);
    }
  }

  let layout_id = canvas_data[id]._data['layout_id'];
  file_ids = canvas_data[id].product_image_settings
    .slice(0, file_ids.length)
    .map((options, i) => {
      if (!group_fields || isInGroup(group_fields, options['Name'])) {
        return file_ids[i];
      }
      return null;
    })
    .filter((file_id) => file_id !== null);

  const { getBannerView } = API_MEDIA;
  const { data: fileIdsData } = await getBannerView({
    file_ids: file_ids.join(' '),
    show_warning: true,
    layout_id: layout_id
  });

  const firstFilePath = fileIdsData.files?.[0]?.path;
  if (firstFilePath) {
    // getDominantColors(firstFilePath, id);
  }


  let files = fileIdsData.files;

  if (!files) return;

  let {
    left,
    top,
    product_height,
    margin,
    imagesData
  } = await calculateDataForAllProductImages(
    files,
    canvas_data[id],
    data
  );

  const fieldsProductImage = canvas_data[id].templateInstance.getFieldsByType(FIELD_TYPE_PRODUCT_IMAGE);

  /* used to save bounding box info */
  const formData = new FormData();
  formData.append('type', 'Product Image');

  imagesData.forEach((item, index) => {
    const { config, x_offset, y_offset, scale, accLeft } = createObjectOfProductImage(
      { left, top, margin, product_height, item },
      index,
      canvas_data[id],
      data,
      dimension,
      shadows
    );
    let auto_position = true;

    if (['0', 'false', false, 0].includes(canvas_data[id]?._data?.product_auto_positioning)) {
      auto_position = false;
    }

    if (auto_position)
      left = accLeft;

    item.image.set({
      ...config,
      templateField: fieldsProductImage?.[index] || null,
      fieldId: fieldsProductImage?.[index].id,
      updateLayoutChanges,
    });
    
    if (
      prevObjWithDataForRestoreOriginalPaths 
      && item.image.id === prevObjWithDataForRestoreOriginalPaths.id 
      && originalPathForRestoreAfterCrop
    ) {
      item.image.originalPathForRestoreAfterCrop = originalPathForRestoreAfterCrop;
    }
    
    scaleControlsCornerSize(item.image);

    canvas.add(item.image);

    /* update bounding box info */
    let bound = item.image.getBoundingRect();
    let elementId = item.image.element_id;
    formData.append('product_image_index[]', index);
    formData.append('element_ids[]', elementId);
    formData.append('p_width[]', bound.width);
    formData.append('p_height[]', bound.height);
    formData.append(`${elementId}_bounding_data`, JSON.stringify(bound));

    canvas_data[id].originCoords.push({
      x: item.image.left - x_offset,
      y: item.image.top - y_offset,
      scaleX: item.image.scaleX / scale,
    });
    replaceSelectedObjectById(item.image);
  });

  /* UPDATE BOUNDING BOX INFO */
  if (previewBoundingBoxData) {
    previewBoundingBoxData.data.push(formDataToObject(formData));
  } else {
    updateBoundingBoxInfo(formData, id);
  }

  reorderObjectCanvas(canvas);
}

const replaceSelectedObjectById = function (newObject) {
  const { selectedObjects } = getScopePage();

  if (selectedObjects.length === 0) {
    return;
  }

  const currentObject = selectedObjects[0];
  if (currentObject.type === 'activeSelection') {
    for (const key in currentObject._objects) {
      if (currentObject._objects[key].id === newObject.id) {
        selectedObjects[0]._objects[key] = newObject;
        return;
      }
    }
  } else if (currentObject.id === newObject.id) {
    selectedObjects[0] = newObject;
  }
};

export function createObjectOfProductImage(
  { left, top, margin, product_height, item },
  index,
  canvasData,
  data,
  dimension,
  shadows,
  fieldsProductImage = null
) {
  const angle = +data?.angle?.[index] || 0;
  const x_offset = +data?.x_offset?.[index] || 0;
  const y_offset = +data?.y_offset?.[index] || 0;
  const scale = +data?.scale?.[index] || 1;
  const moveable = data.moveable && data.moveable[index] !== undefined ? data.moveable[index] : false;
  let bShadow = +data?.p_shadow?.[index];
  const opacity = (Number.isFinite(data?.p_opacity?.[index])) ? +data?.p_opacity?.[index] : 1;

  if (!fieldsProductImage) {
    fieldsProductImage = canvasData.templateInstance.getFieldsByType(FIELD_TYPE_PRODUCT_IMAGE);
  }
  fieldsProductImage = fieldsProductImage[index];
  const productImageSettings = canvasData.product_image_settings[index];
  const visible = data?.p_visible?.[index] ?? (!productImageSettings['Hidden'] || true);
  const ovalShadow = data?.p_oval_shadows?.[index]?.length ? data?.p_oval_shadows?.[index] : null;

  const ovalShadowGroupId = data?.p_oval_shadow_group_ids?.length ? data?.p_oval_shadow_group_ids?.[index] : null;
  let config = {
    left: 0,
    top: 0,
  };

  if (productImageSettings['Option1'] === 'Hero') {
    const { Width: productImageWidth, Height: productImageHeight, Option2: option2, X, Y } = productImageSettings;
    let w = parseInt(productImageWidth);
    const ratio1 = parseInt(productImageWidth) / item.width;
    let h = item.height * ratio1;
    const ratio2 = h / parseInt(productImageHeight);

    if (ratio2 > 1) {
      h = parseInt(productImageHeight);
      w = w / ratio2;
    }
    let hero_left = parseInt(X) + w / 2;
    const hero_top = parseInt(Y) + h / 2;

    if (typeof option2 === 'string' && option2.startsWith('W-')) {
      hero_left = canvasData.dimension['width'] - +option2.split('-')[1] - w / 2;
    }

    config.left = hero_left + x_offset;
    config.top = hero_top + y_offset;
    item.image.scaleToWidth(w);
  } else {
    let wr = item.width * scale;
    let hr = item.height * scale;

    config.left = left + canvasData.product['left'] + item.width / 2 + x_offset;
    config.top = top + (product_height - hr) / 2 + y_offset + hr / 2;
    item.image.scaleToWidth(item.width);

    left += wr / 2 + item.width / 2 + margin;
  }

  config = {
    ...config,
    id: IMAGE_PREFIX_ID + index,
    element_id: fieldsProductImage?.element_id || IMAGE_PREFIX_ID + index,
    originX: 'center',
    originY: 'center',
    lockUniScaling: true,
    selectable: moveable === 'Yes',
    evented: moveable === 'Yes',
    defaultWidth: +productImageSettings['Width'],
    angle,
    order: +productImageSettings['Order'] || fieldsProductImage?.order || 0,
    scaleX: item.image.scaleX * scale,
    scaleY: item.image.scaleY * scale,
    groupName: getGroupNameByAddFieldId(
      String(productImageSettings.id),
      canvasData
    ),
    flipX: !!+data?.p_flipX?.[index],
    flipY: !!+data?.p_flipY?.[index],
    fieldId: productImageSettings.id,
    fieldType: FIELD_TYPE_PRODUCT_IMAGE,
    opacity,
    ovalShadow,
    ovalShadowGroupId,
    gridLayoutInstanceId: canvasData._data.instance_id,
    visible
  };

  config.shadow = getShadowFabricInstance(data.instance_id, config.element_id, shadows, bShadow, config.scaleX, config.scaleY);
  config.locked = getLockValue(data.instance_id, config.element_id);

  let group_x = 0;
  let group_y = 0;
  const { groupName } = config;

  if (groupName && canvasData.smartObjCoords[groupName]) {
    group_x = +canvasData.smartObjCoords[groupName]['X'];
    group_y = +canvasData.smartObjCoords[groupName]['Y'];
  }

  config = {
    ...config,
    left: config.left + group_x - dimension[2] + dimension[4].x,
    top: config.top + group_y - dimension[3] + dimension[4].y,
  };

  if (isNaN(config.scaleX) || isNaN(config.scaleY)) {
    config = {
      ...config,
      scaleX: '0.37',
      scaleY: '0.37',
      left: productImageSettings.X,
      top: productImageSettings.Y
    };
  }

  return { config, x_offset, y_offset, scale, accLeft: left };
}
